import React, { useContext, useRef, useState } from "react";
import supabase from "../supabase/supabaseClient";

import estilo from "./styles/SubirVideo.module.css";
import { DataContext } from "../context/DataContext";
import Cargando from "./Cargando";

function SubirVideo() {
  const { activarSubir, setActivarSubir } = useContext(DataContext);

  function subir() {
    setActivarSubir(!activarSubir);
  }

  const [video, setVideo] = useState([]);
  const [imagen, setImagen] = useState([]);
  const [cargaVideo, setCargaVideo] = useState(false);
  const [tiempo, setTiempo] = useState(null);
  const [numerosAleatorios, setNumerosAleatorios] = useState(null);

  const [formDatos, setFormDatos] = useState({
    usuario: null,
    nombre: null,
    descripcion: null,
  });

  //numeros aletorios
  function generarNumerosAleatorios() {
    const numeros = [];
    while (numeros.length < 3) {
      const numero = Math.floor(Math.random() * 10);
      if (!numeros.includes(numero)) {
        numeros.push(numero);
      }
    }
    setNumerosAleatorios(numeros);
  }

  function handleChange(e) {
    setFormDatos((prevFormDatos) => {
      const value = e.target.value === "" ? null : e.target.value;
      return {
        ...prevFormDatos,
        [e.target.name]: value,
      };
    });
    generarNumerosAleatorios();
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setCargaVideo(true);
    const { data, error } = await supabase
      .from("usuarios")
      .insert({
        usuario: formDatos.usuario + numerosAleatorios.join(""),
        nombre: formDatos.nombre,
        descripcion: formDatos.descripcion,
        tiempo: tiempo,
      })
      .select();

    if (data) {
      // console.log(data);
      setFormDatos({ usuario: null, nombre: null, descripcion: null });
      await handleUpload();
      await handleUploadImage();
    }
    if (error) {
      console.log(error);
    }
    setCargaVideo(false);
  }

  //subir video
  const handleUpload = async () => {
    for (const mp4 of video) {
      const { data, error } = await supabase.storage
        .from("videos")
        .upload(
          `${formDatos.usuario + numerosAleatorios.join("")}/${
            formDatos.nombre
          }`,
          mp4
        );

      if (data) {
        // console.log("subir", data);
      }
      if (error) {
        console.log(error);
      }
    }
  };

  //limpiar input usando useRef
  const inputRef = useRef(null);

  //capturar video
  const handleVideoChange = (e) => {
    const files = Array.from(e.target.files);

    //saber duracion
    const videoElement = document.createElement("video");
    videoElement.addEventListener("loadedmetadata", () => {
      setTiempo(videoElement.duration);
    });
    videoElement.src = URL.createObjectURL(files[0]);

    //saber el peso
    const maximosMB = 50;
    const fileSizeEnMB = files[0].size / (1024 * 1024);

    if (fileSizeEnMB > maximosMB) {
      alert(
        `El archivo seleccionado excede el tamaño máximo de ${maximosMB} MB.`
      );
      inputRef.current.value = "";
    } else {
      setVideo(files);
    }
  };

  //subir imagen
  const handleUploadImage = async () => {
    for (const image of imagen) {
      const { data, error } = await supabase.storage
        .from("fotos")
        .upload(
          `${formDatos.usuario + numerosAleatorios.join("")}/${
            formDatos.nombre
          }`,
          image
        );

      if (data) {
        // console.log("subir", data);
      }
      if (error) {
        console.log(error);
      }
    }
  };

  //capturar imagen
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImagen(files);
  };

  return (
    <div className={estilo.subir_video}>
      <form onSubmit={handleSubmit}>
        <div className={estilo.datos}>
          <label>Nombre de Usuario:</label>
          <input
            onChange={handleChange}
            name="usuario"
            value={formDatos.usuario || ""}
            required
          />
        </div>

        <div className={estilo.datos}>
          <label>Nombre de Video:</label>
          <input
            onChange={handleChange}
            name="nombre"
            value={formDatos.nombre || ""}
            required
          />
        </div>

        <div className={estilo.datos}>
          <label>Descripción:</label>
          <textarea
            onChange={handleChange}
            name="descripcion"
            value={formDatos.descripcion || ""}
            required
          />
        </div>

        <div className={estilo.datos}>
          <label>Video:</label>
          <input
            type="file"
            required
            accept="video/*"
            onChange={handleVideoChange}
            ref={inputRef}
          />
        </div>

        <div className={estilo.datos}>
          <label>Miniatura:</label>
          <input
            type="file"
            required
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>

        <button type="submit">SUBIR</button>

        <div onClick={subir} className={estilo.cerar}>
          <svg width="48" height="48" viewBox="0 0 24 24">
            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z"></path>
          </svg>
        </div>
      </form>

      {cargaVideo && (
        <div className={estilo.cargando}>
          <Cargando></Cargando>
          <p>Subiendo Video...</p>
        </div>
      )}
    </div>
  );
}

export default SubirVideo;
